export default __webpack_public_path__ + "static/media/rnr-sports-table-9.ecab3a48.webp";